export enum POGRNField{
    PONumber=1,
    PODate=2,
    InvoiceImage=4,
    GRN=3,
    NoOfCustomersAttended=5,
    NoOfCustomersConverted=6,
    CaptureImage= 7
}